import React from 'react';
import { useLocale } from 'locale';
import { Bullet, TickerChip, TickerDivider, TickerItemWrapper, TickerText, ValueDescGroup } from './styled';

export interface ITickerItem {
  title: string;
  count: number;
  delta: number;
}

// physical (RTL) left-to-right order confirmed via Figma (node 11156:54476): period-label, badge,
// bullet, value, description — i.e. first DOM child lands physically rightmost, so the JSX order
// here (description, value, bullet, badge, label) is the reverse of that reading order.
export const TickerItem: React.FC<{ item: ITickerItem }> = ({ item }) => {
  const { t, formatNumber } = useLocale();
  const { title, count, delta } = item;

  return (
    <TickerItemWrapper>
      <ValueDescGroup>
        <TickerText>{title}</TickerText>
        <TickerText weight="bold">{formatNumber(count)}</TickerText>
      </ValueDescGroup>
      {Number.isFinite(delta) ? (
        <>
          <Bullet>•</Bullet>
          <TickerChip isGreen={delta > 0}>{delta > 0 ? '+' : ''}{delta}%</TickerChip>
          <TickerText>{t('investors.market.result.period')}</TickerText>
        </>
      ) : null}
      <TickerDivider />
    </TickerItemWrapper>
  );
};
